'use strict';

/** Activate toggling buttons with aria-attributes.
 *
 * Call on button element.
 * The target element is found from the button's 'aria-controls' attribute.
 * You can trigger class changes on the target, the button and the document body.
 *
 */


$.fn.toggler = function (options) {

    const opt = $.extend({
        targetClass: 'is-open',
        triggerClass: '',
        bodyClass: ''
    }, options);

    $( this ).each(function() {

        let trigger = $( this );

        let target = $('#' + trigger.attr('aria-controls'));

        trigger.on('click', function() {
            if ( trigger.attr('aria-expanded') === 'false' ) {
                trigger.attr('aria-expanded', 'true');
                target.attr('aria-hidden', 'false');
                if ( opt.targetClass ) {
                    target.addClass(opt.targetClass);
                }
                if ( opt.triggerClass ) {
                    trigger.addClass(opt.triggerClass);
                }
                if ( opt.bodyClass ) {
                    window.global.body.addClass(opt.bodyClass);
                }
            } else {
                trigger.attr('aria-expanded', 'false');
                target.attr('aria-hidden', 'true');
                if ( opt.targetClass ) {
                    target.removeClass(opt.targetClass);
                }
                if ( opt.triggerClass ) {
                    trigger.removeClass(opt.triggerClass);
                }
                if ( opt.bodyClass ) {
                    window.global.body.removeClass(opt.bodyClass);
                }
            }
        });
    });

    return this;
};